"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerMeta = void 0;
const getScore_1 = __importDefault(require("@opsbase/lib-form/helpers/getScore"));
const isFailed_1 = __importDefault(require("@opsbase/lib-form/helpers/isFailed"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const FailIcon_1 = __importDefault(require("@opsbase/web-icons/icons/FailIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = (opacity, big, bgColor, pdf) => ({
    root: {
        position: 'absolute',
        top: pdf ? undefined : 0,
        bottom: pdf ? 2 : undefined,
        right: pdf ? 2 : 0,
        zIndex: 8,
        padding: pdf ? 2 : '5px 3px',
        textAlign: 'right',
        backgroundColor: bgColor,
        color: 'white',
        maxWidth: 200,
        width: big ? 24 : 14,
        height: pdf ? 14 : big ? 28 : 20,
        overflow: 'hidden',
        opacity: pdf ? undefined : opacity,
        borderRadius: pdf ? '50%' : '0 0 0 50%',
        transition: pdf ? undefined : 'width 0.3s, borderRadius 0.3s, opacity 0.3s',
        '& .innerBig': pdf ? undefined : { display: 'none' },
        '&:hover': pdf
            ? undefined
            : {
                borderRadius: 0,
                width: '100%',
                height: '100%',
                opacity: 1,
                '& .innerBig': { display: 'block' },
                '& .innerSmall': { display: 'none' },
            },
    },
});
exports.AnswerMeta = react_1.default.memo((props) => {
    const { form, isScoreEnabled = false, questionNodeId, big = false, opacity = 0.6, pdf = false, } = props;
    const question = form.questions[questionNodeId];
    /*
    const questionNode = form.questions[questionNodeId]
    const { max: maxScore, total: score } = getScore(
        question,
        form.questions,
        form.answers,
        form.rules,
        [question]
    )
    const failed = hasFailed(question, form.questions, form.answers, form.rules)
     */
    const { max: maxScore, total: score } = (0, getScore_1.default)(form, question);
    const failed = (0, isFailed_1.default)(form, question);
    let bgColor = 'transparent';
    let innerSmall, innerBig;
    // IMMEDIATE FAILED
    if (failed) {
        bgColor = lib_palette_1.default.error.main;
        innerSmall = react_1.default.createElement(FailIcon_1.default, { color: lib_palette_1.default.White, size: big ? 18 : 10 });
        innerBig = (react_1.default.createElement(Horizontal_1.default, { centered: true },
            react_1.default.createElement(FailIcon_1.default, { color: lib_palette_1.default.White, size: big ? 24 : 18 }),
            react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('this-answer-failed'))));
    }
    // SCORED
    else if (isScoreEnabled && maxScore > 0 && score !== undefined) {
        bgColor = lib_palette_1.default.secondary.main;
        innerSmall = react_1.default.createElement(Text_1.default, { variant: big ? 'body' : 'tiny' }, score || 0);
        innerBig = (react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('this-answer-scored', {
            score: score || 0,
            max: maxScore,
            perc: Math.floor((score / maxScore) * 100),
        })));
    }
    const myCss = (0, web_css_1.default)(makeMyClasses, [opacity, big, bgColor, pdf]);
    if (!innerSmall)
        return null;
    return (react_1.default.createElement("div", { className: myCss.root },
        react_1.default.createElement("div", { className: 'innerSmall' }, innerSmall),
        !pdf && react_1.default.createElement("div", { className: 'innerBig' }, innerBig)));
});
exports.default = exports.AnswerMeta;
